import React from 'react';

export type AssetsViewContextValue = "AssetSummary" | "CurrentNetWorth";

const defaultValue: AssetsViewContextValue = "AssetSummary";

export default React.createContext<AssetsViewContextValue>(defaultValue);